// export const getAvatar = (state) => state.amm.avatars;
export const getAvatarActivities = (state) => state.avatar.activityEvents;
export const getAvatarBlocked = (state) => state.avatar.blockedAvatars;
